import { DehydratedState, hydrate, QueryClient } from "@tanstack/react-query";

// cache a reference for use on client-side
let __client: QueryClient;

function initializeClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnMount: false,
        // With SSR, we usually want to set some default staleTime
        // above 0 to avoid refetching immediately on the client
        staleTime: Infinity,
      },
    },
  });
}

function hydrateClient(client: QueryClient, state?: DehydratedState[]) {
  if (Array.isArray(state) && state.length) {
    const dehydratedState = state.reduce(
      (acc, { mutations = [], queries = [] }) => {
        acc.mutations.push(...mutations);
        acc.queries.push(...queries);
        return acc;
      },
      { mutations: [], queries: [] },
    );

    hydrate(client, dehydratedState);
  }
}

export function configureClient(state?: DehydratedState[]): QueryClient {
  if (typeof window === "undefined") {
    // always create a new instance server-side
    return initializeClient();
  }
  if (!__client) {
    __client = initializeClient();
    hydrateClient(__client, state);
  }
  return __client;
}
